export default __webpack_public_path__ + "static/media/sn-label.51452f7c.svg";